import rest from 'rest';
import mime from 'rest/interceptor/mime';
import SuccessCodesInterceptor from './SuccessCodesInterceptor';
import FailureCodesInterceptor from './FailureCodesInterceptor';

class RestBuilder {
  constructor() {
    this.configuration = {};
  }

  mimeJson() {
    this.configuration.mime = 'application/json';
    return this;
  }

  successCodes(successCodes) {
    this.configuration.successCodes = successCodes;
    return this;
  }

  failureCodes(failureCodes) {
    this.configuration.failureCodes = failureCodes;
    return this;
  }

  build() {
    let configuredRest = rest;
    if (this.configuration.mime) {
      configuredRest = configuredRest.wrap(mime, { mime: 'application/json' });
    }

    if (this.configuration.successCodes) {
      configuredRest = configuredRest.wrap(SuccessCodesInterceptor, { successCodes: this.configuration.successCodes });
    }

    if (this.configuration.failureCodes) {
      configuredRest = configuredRest.wrap(FailureCodesInterceptor, { failureCodes: this.configuration.failureCodes });
    }

    return configuredRest;
  }
}

export default RestBuilder;



/** WEBPACK FOOTER **
 ** ./src/rest/RestBuilder.js
 **/